import IMBgImage from "../../components/common/IMBgImage";
import IMTitle from "../../components/typography/IMText";
import IMText from "../../components/typography/IMTitle";
import IMButton from "../../components/common/buttons/IMButton";
import IMImageSliderProgress from "../../components/common/IMImageSliderProgress";
import { useParams, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import IMPage from "../../components/common/layout/IMPage";

const Intro = (props: React.HTMLAttributes<HTMLDivElement>) => {
	const params = useParams();
	const navigate = useNavigate();
	const position = parseInt(params.position || "0");

	const setPosition = (pos: number) => {
		if (pos > 2) {
			navigate("/start");
		} else {
			navigate(`/intro/${pos}`);
		}
	};

	return (
		<IMPage>
			<Box
				sx={{
					position: "relative",
					height: "100%",
				}}
			>
				<Box
					sx={{
						position: "absolute",
						height: "100%",
						width: "100%",
						zIndex: 0,
					}}
				>
					{position === 0 && (
						<IMBgImage
							src={`${process.env.PUBLIC_URL}/assets/intro-01.webp`}
							alt=""
						/>
					)}
					{position === 1 && (
						<IMBgImage
							src={`${process.env.PUBLIC_URL}/assets/intro-02.webp`}
							alt=""
						/>
					)}
					{position === 2 && (
						<IMBgImage
							src={`${process.env.PUBLIC_URL}/assets/intro-03.webp`}
							alt=""
						/>
					)}
				</Box>
				<Box
					sx={{
						position: "absolute",
						width: "100%",
						bottom: 0,
						zIndex: 1,
					}}
				>
					<Box
						sx={{
							marginBottom: "30px",
							marginX: "16px",
						}}
					>
						{position === 0 && (
							<div>
								<IMTitle weight="700" size="28px" color="#FFFFFF">
									Добро пожаловать в iMigrate
								</IMTitle>
								<IMText
									weight="500"
									size="18px"
									color="#FFFFFF"
									opacity={0.7}
									props={{ marginTop: "10px" }}
								>
									Ваш помощник номер один для эмиграции в другие страны
								</IMText>
							</div>
						)}
						{position === 1 && (
							<div>
								<IMTitle weight="700" size="28px" color="#FFFFFF">
									Выберите идеальную для вас страну
								</IMTitle>
								<IMText
									weight="500"
									size="18px"
									color="#FFFFFF"
									opacity={0.7}
									props={{ marginTop: "10px" }}
								>
									Наш подробный анализ поможет вам выбрать подходящую страну в
									соответствии с вашими критериями
								</IMText>
							</div>
						)}
						{position === 2 && (
							<div>
								<IMTitle weight="700" size="28px" color="#FFFFFF">
									Получите помощь в эмиграции
								</IMTitle>
								<IMText
									weight="500"
									size="18px"
									color="#FFFFFF"
									opacity={0.7}
									props={{ marginTop: "10px" }}
								>
									Мы поможем вам выбрать агентство, чтобы получить качественную
									и быструю помощь в эмиграции.
								</IMText>
							</div>
						)}
					</Box>
				</Box>
			</Box>
			<Box
				sx={{
					paddingX: "16px",
					display: "flex",
					height: "48px",
					marginBottom: "30px",
				}}
			>
				<IMImageSliderProgress
					position={position}
					onSelectPosition={(pos) => setPosition(pos)}
				></IMImageSliderProgress>
				<IMButton
					sx={{ width: "100%" }}
					onClick={() => setPosition(position + 1)}
				>
					Далее
				</IMButton>
			</Box>
		</IMPage>
	);
};

export default Intro;
